/* /assets/ctr-recipe-categories.js */

(function () {
  function initSection(section) {
    var tabs = section.querySelectorAll('.ctr-recipe-categories__tab');
    var panels = section.querySelectorAll('.ctr-recipe-categories__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = parseInt(tab.dataset.tabIndex, 10);

        tabs.forEach(function (t) {
          t.classList.remove('ctr-recipe-categories__tab--active');
        });
        tab.classList.add('ctr-recipe-categories__tab--active');

        panels.forEach(function (p) {
          p.classList.remove('ctr-recipe-categories__panel--active');
        });
        if (panels[index]) {
          panels[index].classList.add('ctr-recipe-categories__panel--active');
        }

        var activeSwiper = panels[index] && panels[index].querySelector('.ctr-recipe-categories__swiper-mobile');
        if (activeSwiper && activeSwiper.swiper) {
          activeSwiper.swiper.update();
        }
      });
    });

    panels.forEach(function (panel) {
      initDesktopSlider(panel);
      initMobileSwiper(panel);
    });

    initTabsArrows(section);
    initSearch(section);
  }

  function initSearch(section) {
    var input = section.querySelector('[data-recipe-search-input]');
    var submitBtn = section.querySelector('[data-recipe-search-btn]');
    if (!input || !submitBtn) return;

    var catOriginal = section.querySelector('[data-categories-original]');
    var catContent = section.querySelector('[data-categories-content]');
    var searchResults = section.querySelector('[data-search-results]');
    var searchGrid = section.querySelector('[data-search-grid]');
    var searchEmpty = section.querySelector('[data-search-empty]');
    var clearBtn = section.querySelector('[data-search-clear]');
    var existingBtn = section.querySelector('.ctr-recipe-categories__card-btn');
    var btnLabel = existingBtn ? existingBtn.textContent.trim() : 'View Recipe';

    var recipeIndex = buildRecipeIndex(section);
    var searchSwiper = null;

    function triggerSearch() {
      var query = input.value.trim();
      if (!query) return;
      performSearch(query);
    }

    submitBtn.addEventListener('click', triggerSearch);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        triggerSearch();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        hideResults();
      });
    }

    function performSearch(query) {
      var lowerQuery = query.toLowerCase();
      var results = recipeIndex.filter(function (recipe) {
        return recipe.title.toLowerCase().indexOf(lowerQuery) !== -1 ||
               recipe.tag.toLowerCase().indexOf(lowerQuery) !== -1;
      });
      renderResults(results);
    }

    function buildCard(recipe) {
      var card = document.createElement('div');
      card.className = 'ctr-recipe-categories__card ctr-recipe-categories__card--small';

      var imageHtml = '';
      if (recipe.image) {
        imageHtml =
          '<div class="ctr-recipe-categories__card-image">' +
          '<img src="' + recipe.image + '" alt="' + escapeHtml(recipe.title) + '" loading="lazy" width="800" height="800">' +
          '</div>';
      }

      var tagHtml = '';
      if (recipe.tag) {
        tagHtml = '<span class="ctr-recipe-categories__card-tag">' + escapeHtml(recipe.tag) + '</span>';
      }

      var excerptHtml = '';
      if (recipe.excerpt) {
        excerptHtml = '<p class="ctr-recipe-categories__card-excerpt">' + escapeHtml(recipe.excerpt) + '</p>';
      }

      card.innerHTML =
        imageHtml +
        '<div class="ctr-recipe-categories__card-body">' +
        tagHtml +
        '<div class="ctr-recipe-categories__card-info">' +
        '<h3 class="ctr-recipe-categories__card-name">' + escapeHtml(recipe.title) + '</h3>' +
        excerptHtml +
        '</div>' +
        '</div>' +
        '<a href="' + recipe.url + '" class="ctr-recipe-categories__card-btn">' + escapeHtml(btnLabel) + '</a>';

      return card;
    }

    function buildMobileCard(recipe) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';

      var card = document.createElement('div');
      card.className = 'ctr-recipe-categories__card ctr-recipe-categories__card--vertical';

      var imageHtml = '';
      if (recipe.image) {
        imageHtml =
          '<div class="ctr-recipe-categories__card-image">' +
          '<img src="' + recipe.image + '" alt="' + escapeHtml(recipe.title) + '" loading="lazy" width="600" height="600">' +
          '</div>';
      }

      var tagHtml = '';
      if (recipe.tag) {
        tagHtml = '<span class="ctr-recipe-categories__card-tag">' + escapeHtml(recipe.tag) + '</span>';
      }

      var excerptHtml = '';
      if (recipe.excerpt) {
        excerptHtml = '<p class="ctr-recipe-categories__card-excerpt">' + escapeHtml(recipe.excerpt) + '</p>';
      }

      card.innerHTML =
        imageHtml +
        '<div class="ctr-recipe-categories__card-body">' +
        tagHtml +
        '<div class="ctr-recipe-categories__card-info">' +
        '<h3 class="ctr-recipe-categories__card-name">' + escapeHtml(recipe.title) + '</h3>' +
        excerptHtml +
        '</div>' +
        '</div>' +
        '<a href="' + recipe.url + '" class="ctr-recipe-categories__card-btn">' + escapeHtml(btnLabel) + '</a>';

      slide.appendChild(card);
      return slide;
    }

    function renderResults(recipes) {
      destroySearchSwiper();
      searchGrid.innerHTML = '';

      if (catOriginal) catOriginal.style.display = 'none';
      if (catContent) catContent.style.display = 'none';
      searchResults.style.display = '';
      if (clearBtn) clearBtn.style.display = '';

      if (recipes.length === 0) {
        searchEmpty.style.display = '';
        searchGrid.style.display = 'none';
        return;
      }

      searchEmpty.style.display = 'none';
      searchGrid.style.display = '';

      var grid = document.createElement('div');
      grid.className = 'ctr-recipe-categories__search-results-grid';
      recipes.forEach(function (recipe) {
        grid.appendChild(buildCard(recipe));
      });
      searchGrid.appendChild(grid);

      var mobileWrap = document.createElement('div');
      mobileWrap.className = 'ctr-recipe-categories__mobile-slider ctr-recipe-categories__search-mobile-slider';

      var swiperEl = document.createElement('div');
      swiperEl.className = 'swiper ctr-recipe-categories__swiper-mobile';

      var wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      recipes.forEach(function (recipe) {
        wrapper.appendChild(buildMobileCard(recipe));
      });

      swiperEl.appendChild(wrapper);
      mobileWrap.appendChild(swiperEl);

      var controls = document.createElement('div');
      controls.className = 'ctr-recipe-categories__controls';
      controls.innerHTML =
        '<div class="ctr-recipe-categories__pagination ctr-recipe-categories__search-pagination"></div>' +
        '<div class="ctr-recipe-categories__nav">' +
        '<button class="ctr-recipe-categories__nav-btn ctr-recipe-categories__search-prev" type="button" aria-label="Previous">' +
        '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.5" stroke="currentColor"/><path d="M23 14L17 20L23 26" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<button class="ctr-recipe-categories__nav-btn ctr-recipe-categories__search-next" type="button" aria-label="Next">' +
        '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="currentColor"/><path d="M17 14L23 20L17 26" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '</div>';

      mobileWrap.appendChild(controls);
      searchGrid.appendChild(mobileWrap);

      if (typeof Swiper !== 'undefined') {
        searchSwiper = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          pagination: {
            el: mobileWrap.querySelector('.ctr-recipe-categories__search-pagination'),
            clickable: true,
            bulletClass: 'ctr-recipe-categories__dot',
            bulletActiveClass: 'ctr-recipe-categories__dot--active'
          },
          navigation: {
            prevEl: mobileWrap.querySelector('.ctr-recipe-categories__search-prev'),
            nextEl: mobileWrap.querySelector('.ctr-recipe-categories__search-next')
          }
        });
      }
    }

    function destroySearchSwiper() {
      if (searchSwiper) {
        searchSwiper.destroy(true, true);
        searchSwiper = null;
      }
    }

    function hideResults() {
      destroySearchSwiper();
      searchResults.style.display = 'none';
      searchGrid.innerHTML = '';
      if (clearBtn) clearBtn.style.display = 'none';
      if (catOriginal) catOriginal.style.display = '';
      if (catContent) catContent.style.display = '';
    }
  }

  function buildRecipeIndex(section) {
    var index = [];
    var seen = {};

    function indexCards(container, selectors) {
      var cards = container.querySelectorAll(selectors.card);
      cards.forEach(function (card) {
        var linkEl = card.querySelector(selectors.btn);
        var nameEl = card.querySelector(selectors.name);
        var imgEl = card.querySelector(selectors.image);
        var tagEl = card.querySelector(selectors.tag);
        var excerptEl = card.querySelector(selectors.excerpt);

        if (!linkEl || !nameEl) return;

        var url = linkEl.getAttribute('href') || '';
        if (seen[url]) return;
        seen[url] = true;

        index.push({
          title: nameEl.textContent.trim(),
          url: url,
          image: imgEl ? imgEl.getAttribute('src') : '',
          tag: tagEl ? tagEl.textContent.trim() : '',
          excerpt: excerptEl ? excerptEl.textContent.trim() : ''
        });
      });
    }

    indexCards(section, {
      card: '.ctr-recipe-categories__card',
      btn: '.ctr-recipe-categories__card-btn',
      name: '.ctr-recipe-categories__card-name',
      image: '.ctr-recipe-categories__card-image img',
      tag: '.ctr-recipe-categories__card-tag',
      excerpt: '.ctr-recipe-categories__card-excerpt'
    });

    document.querySelectorAll('[data-section-type="ctr-featured-recipes"]').forEach(function (featSection) {
      indexCards(featSection, {
        card: '.ctr-featured-recipes__card',
        btn: '.ctr-featured-recipes__card-btn',
        name: '.ctr-featured-recipes__card-name',
        image: '.ctr-featured-recipes__card-image img',
        tag: '.ctr-featured-recipes__card-tag',
        excerpt: '.ctr-featured-recipes__card-excerpt'
      });
    });

    return index;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function initTabsArrows(section) {
    var tabsContainer = section.querySelector('[data-tabs-scroll]');
    var prevBtn = section.querySelector('[data-tabs-prev]');
    var nextBtn = section.querySelector('[data-tabs-next]');
    if (!tabsContainer || !prevBtn || !nextBtn) return;

    var scrollAmount = 200;

    function updateArrows() {
      var sl = tabsContainer.scrollLeft;
      var maxScroll = tabsContainer.scrollWidth - tabsContainer.clientWidth;
      var atStart = sl <= 2;
      var atEnd = sl >= maxScroll - 2;

      prevBtn.disabled = atStart;
      prevBtn.classList.toggle('ctr-recipe-categories__tabs-arrow--disabled', atStart);

      nextBtn.disabled = atEnd;
      nextBtn.classList.toggle('ctr-recipe-categories__tabs-arrow--disabled', atEnd);

      var wrapper = tabsContainer.closest('.ctr-recipe-categories__tabs-wrapper');
      if (wrapper) {
        wrapper.classList.toggle('ctr-recipe-categories__tabs-wrapper--fade-left', !atStart);
        wrapper.classList.toggle('ctr-recipe-categories__tabs-wrapper--fade-right', !atEnd);
      }
    }

    prevBtn.addEventListener('click', function () {
      tabsContainer.scrollLeft -= scrollAmount;
    });

    nextBtn.addEventListener('click', function () {
      tabsContainer.scrollLeft += scrollAmount;
    });

    tabsContainer.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initDesktopSlider(panel) {
    var pages = panel.querySelectorAll('.ctr-recipe-categories__page');
    var dots = panel.querySelectorAll('.ctr-recipe-categories__desktop-slider .ctr-recipe-categories__dot');
    var prevBtn = panel.querySelector('.ctr-recipe-categories__desktop-slider .ctr-recipe-categories__nav-prev');
    var nextBtn = panel.querySelector('.ctr-recipe-categories__desktop-slider .ctr-recipe-categories__nav-next');
    var currentPage = 0;
    var totalPages = pages.length;

    if (totalPages <= 1) return;

    function updateNavState() {
      if (prevBtn) {
        prevBtn.disabled = currentPage === 0;
        prevBtn.classList.toggle('ctr-recipe-categories__nav-btn--disabled', currentPage === 0);
      }
      if (nextBtn) {
        nextBtn.disabled = currentPage >= totalPages - 1;
        nextBtn.classList.toggle('ctr-recipe-categories__nav-btn--disabled', currentPage >= totalPages - 1);
      }
    }

    function goToPage(index) {
      if (index < 0 || index >= totalPages) return;
      pages.forEach(function (p) {
        p.classList.remove('ctr-recipe-categories__page--active');
      });
      dots.forEach(function (d) {
        d.classList.remove('ctr-recipe-categories__dot--active');
      });
      pages[index].classList.add('ctr-recipe-categories__page--active');
      if (dots[index]) dots[index].classList.add('ctr-recipe-categories__dot--active');
      currentPage = index;
      updateNavState();
    }

    updateNavState();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPage(currentPage + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToPage(parseInt(dot.dataset.dot, 10));
      });
    });
  }

  function initMobileSwiper(panel) {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = panel.querySelector('.ctr-recipe-categories__swiper-mobile');
    if (!swiperEl) return;

    var paginationEl = panel.querySelector('.ctr-recipe-categories__mobile-pagination');
    var prevBtn = panel.querySelector('.ctr-recipe-categories__mobile-prev');
    var nextBtn = panel.querySelector('.ctr-recipe-categories__mobile-next');

    new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 16,
      pagination: {
        el: paginationEl,
        clickable: true,
        bulletClass: 'ctr-recipe-categories__dot',
        bulletActiveClass: 'ctr-recipe-categories__dot--active'
      },
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'ctr-recipe-categories__nav-btn--disabled'
      }
    });
  }

  function setup() {
    document.querySelectorAll('[data-section-type="ctr-recipe-categories"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-section-type="ctr-recipe-categories"]');
      if (section) initSection(section);
    });
  }
})();
